import { MUITab } from "@abb/arcadia-ui-react"
import { useEffect, useState } from "react"
import { Navigate, useNavigate, useParams } from "react-router-dom"
import { digitalManagerApi } from "../../../../../services/api"
import {
  DiMaDetailsHeader,
  DiMaDetailsHeaderProps,
} from "../../../../components/DiMaDetailsHeader"
import { DiMaProgress } from "../../../../components/DiMaProgress"
import { TrainingGet } from "../../../../models/Training"
import { TrainingCourseGet } from "../../../../models/TrainingCourse"
import { useHashTab } from "../../../../../hooks/useHashTab"
import { TrainingCourseDetails } from "./details_tab/TrainingCourseDetails"

export function TrainingCourseContainer() {
  const { trainingId, courseId } = useParams()
  const navigate = useNavigate()
  const { activeTab, handleTabChange } = useHashTab("details")

  const [trainingCourse, setTrainingCourse] = useState<TrainingCourseGet>()
  const [training, setTraining] = useState<TrainingGet>()

  const returnURL = `/trainings/${trainingId}#courses`

  useEffect(() => {
    if (trainingId && courseId) {
      digitalManagerApi
        .get<TrainingCourseGet>(`/trainings/${trainingId}/courses/${courseId}`)
        .then((res) => {
          setTrainingCourse(res.data)
        })
        .catch(() => {
          navigate(returnURL)
        })
    }
  }, [navigate, trainingId, courseId, returnURL])

  useEffect(() => {
    if (trainingId) {
      digitalManagerApi
        .get<TrainingGet>(`/trainings/${trainingId}`)
        .then((res) => {
          setTraining(res.data)
        })
        .catch(() => {
          navigate(returnURL)
        })
    }
  }, [navigate, trainingId, returnURL])

  if (!trainingId || !courseId) {
    return <Navigate to="/trainings" />
  }

  if (!trainingCourse || !training) {
    return <DiMaProgress />
  }

  const detailsHeaderProps: DiMaDetailsHeaderProps = {
    url: returnURL,
    title: trainingCourse.name,
    label: "Course ID",
    subtitle: trainingCourse.id,
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
      <DiMaDetailsHeader {...detailsHeaderProps} />
      <MUITab
        tabItems={[{ id: "details", label: "Details" }]}
        value={activeTab}
        handleChange={handleTabChange}
      />
      {activeTab === "details" && (
        <TrainingCourseDetails
          training={training}
          trainingCourse={trainingCourse}
          setTrainingCourse={setTrainingCourse}
        />
      )}
    </div>
  )
}
